
























































import { Component, Vue, Watch } from "vue-property-decorator";
import { WorkerDetailsModule } from "@/store/modules/workerDetails";
import SkillDto from "@/models/Skills/SkillDto";
import GiganautVueDialog from "@/components/Shared/GiganautVueDialog";
import WorkerSkillDto from "@/models/WorkerSkills/WorkerSkillDto";
import CreateWorkerSkillRequest from "@/models/WorkerSkills/CreateWorkerSkillRequest";
import WorkerSkillStatus from "@/models/WorkerSkills/WorkerSkillStatus";

@Component({
  name: "WorkerSkillCreate",
})
export default class extends GiganautVueDialog {
  public dialog = false;
  skill: SkillDto = new SkillDto();
  isVerified = false;
  
 @Watch('dialog')
  async onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.skill = new SkillDto();
      this.isVerified = false;
    }
  }

  get skills() {
    return WorkerDetailsModule.agencyAttributes.skills;
  }

  async save() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }
    const request = new CreateWorkerSkillRequest();
    request.skillId = this.skill.id;
    if (this.isVerified){
        request.status = WorkerSkillStatus.Verified;
    } else {
        request.status = WorkerSkillStatus.Pending;
    }
    request.source = 1; // Manual
    await WorkerDetailsModule.createSkill(request);
    this.dialog = false;
  }
}
